import React from 'react'
import PropTypes from 'prop-types'

import CountdownTimer from '../../Shared/CountdownTimer'

function BonusCreditsBar({
  barColor, content, creditsAdded, endingDate, useTimer,
}) {
  const secondaryBarColor = barColor === 'red' ? 'is-secondary-color' : ''

  return (
    <a href="/pages/cgtrader-loyalty-discounts" className="timer-strip--top-bar">
      <div className={`timer-strip ${secondaryBarColor}`}>
        <div className="timer-row">
          <div className="timer-strip__item timer-strip__item--content">{content}</div>
          <div className="timer-strip__item">
            <span className="timer-strip__item--text">Use</span>
            <strong className="u-ml10 u-mr10"> ${creditsAdded} bonus credits </strong>
            <span className="timer-strip__item--text">on 3D models!</span>
          </div>
          {useTimer && (
            <div className="timer-strip__item no-borders">
              <span className="timer-strip__item--text">Offer expires in</span>
              <div className="big-text u-ml10">
                <CountdownTimer targetDate={endingDate} />
              </div>
            </div>
          )}
          <div className="timer-strip__item timer-strip__item--button">
            <div className="button learn-more-button">Learn more</div>
          </div>
        </div>
      </div>
    </a>
  )
}

BonusCreditsBar.propTypes = {
  barColor: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  creditsAdded: PropTypes.number.isRequired,
  endingDate: PropTypes.number.isRequired,
  useTimer: PropTypes.bool.isRequired,
}

export default BonusCreditsBar
